!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core"), require("@material-ui/icons/FormatBold"), require("@material-ui/icons/FormatListBulleted"), require("@material-ui/icons/FormatListNumbered"), require("@material-ui/icons/FormatItalic"), require("@material-ui/icons/FormatUnderlined"), require("@material-ui/icons/SpaceBar"), require("@material-ui/icons/StrikethroughS"), require("classnames"), require("formik"), require("draft-js"), require("react"), require("@campfire/titular-tooltip"), require("@campfire/hover-link/lib"), require("@material-ui/icons/Link"), require("@material-ui/icons/OpenInNew"), require("@material-ui/icons/Edit")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core", "@material-ui/icons/FormatBold", "@material-ui/icons/FormatListBulleted", "@material-ui/icons/FormatListNumbered", "@material-ui/icons/FormatItalic", "@material-ui/icons/FormatUnderlined", "@material-ui/icons/SpaceBar", "@material-ui/icons/StrikethroughS", "classnames", "formik", "draft-js", "react", "@campfire/titular-tooltip", "@campfire/hover-link/lib", "@material-ui/icons/Link", "@material-ui/icons/OpenInNew", "@material-ui/icons/Edit"], t) : t((e = e || self)["campfire-rich-editor"] = {}, e.core, e.FormatBold, e.FormatListBulleted, e.FormatListNumbered, e.FormatItalic, e.FormatUnderlined, e.SpaceBar, e.StrikethroughS, e.classNames, e.formik, e.draftJs, e.React, e.titularTooltip, e.lib, e.LinkIcon, e.OpenInNewIcon, e.EditIcon);
}(this, function (e, t, r, n, o, a, i, l, c, u, s, d, m, p, f, y, g, h) {
  "use strict";

  r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n, o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
  var b = "default" in m ? m.default : m;
  y = y && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y, g = g && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g, h = h && Object.prototype.hasOwnProperty.call(h, "default") ? h.default : h;

  var _E = function E() {
    return (_E = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

      return e;
    }).apply(this, arguments);
  },
      S = function S(e) {
    var r = e.onClick,
        n = e.label,
        o = e.active,
        a = e.Icon;
    return b.createElement(p.TitularTooltip, {
      enterDelay: 400,
      description: n,
      placement: "top"
    }, b.createElement(t.IconButton, {
      size: "small",
      onMouseDown: r
    }, b.createElement(a, {
      fontSize: "small",
      style: o ? {
        color: "#2196f3"
      } : void 0
    }, n)));
  };

  function v(e) {
    switch (e.getType()) {
      case "blockquote":
        return "RichEditor-blockquote";

      default:
        return "";
    }
  }

  var k = function k(e) {
    var t = e.onToggle,
        r = e.style,
        n = e.label,
        o = e.active,
        a = e.Icon;
    return b.createElement(S, {
      onClick: function onClick(e) {
        e.preventDefault(), t(r);
      },
      active: o,
      Icon: a,
      label: n
    });
  },
      C = function C(e) {
    var t = e.onToggle,
        r = e.editorState,
        n = e.styles,
        o = r.getSelection(),
        a = r.getCurrentContent().getBlockForKey(o.getStartKey()).getType();
    return b.createElement(b.Fragment, null, n.map(function (e) {
      return b.createElement(k, {
        key: e.label,
        active: e.style === a,
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      w = function w(e) {
    var t = e.onToggle,
        r = e.editorState,
        n = e.styles,
        o = r.getCurrentInlineStyle();
    return b.createElement(b.Fragment, null, n.map(function (e) {
      return b.createElement(k, {
        key: e.label,
        active: o.has(e.style),
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      L = t.withStyles(function () {
    return {
      tooltip: {
        backgroundColor: "#ffffff",
        color: "#242424",
        padding: 0,
        width: 360,
        fontSize: 15,
        boxShadow: "0 2px 10px 0 rgba(21, 27, 38, 0.1)",
        borderRadius: 4,
        border: "solid 1px #e9e9e9"
      }
    };
  })(t.Tooltip),
      x = function x(e) {
    var r = e.contentState,
        n = e.entityKey,
        o = e.openLinkDialog,
        a = e.children,
        i = r.getEntity(n).getData().url;
    return b.createElement(L, {
      placement: "top",
      title: b.createElement(b.Fragment, null, b.createElement(t.Box, {
        style: {
          boxSizing: "border-box"
        },
        width: 1,
        height: 1,
        padding: 2,
        paddingLeft: 3
      }, b.createElement(t.Box, {
        width: 1,
        display: "flex",
        justifyContent: "flex-end"
      }, b.createElement(f.HoverText, {
        variant: "body2",
        color: "primary",
        onClick: function onClick() {
          return o(i, n);
        },
        gutterBottom: !0
      }, "Edit link", b.createElement(h, {
        style: {
          marginLeft: 4,
          marginBottom: -4
        },
        fontSize: "small"
      }))), b.createElement(f.HoverLink, {
        target: "_blank",
        rel: "noopener",
        to: i,
        external: !0,
        color: "textSecondary",
        hoverColor: "textSecondary"
      }, b.createElement(t.Typography, {
        display: "inline",
        variant: "body2",
        style: {
          wordBreak: "break-all",
          display: "block"
        }
      }, b.createElement(g, {
        style: {
          fontSize: 14,
          marginRight: 8,
          marginBottom: -2
        }
      }), i)))),
      enterDelay: 175,
      leaveDelay: 225,
      interactive: !0
    }, b.createElement("span", null, b.createElement(f.HoverLink, {
      to: i,
      external: !0,
      target: "_blank",
      rel: "noopener",
      color: "primary",
      hoverColor: "primary"
    }, a)));
  },
      O = function O(e) {
    var t = e.openLinkDialogWithUrl;
    return new d.CompositeDecorator([{
      strategy: D,
      component: x,
      props: {
        openLinkDialog: t
      }
    }]);
  };

  function D(e, t, r) {
    e.findEntityRanges(function (e) {
      var t = e.getEntity();
      return null !== t && "LINK" === r.getEntity(t).getType();
    }, t);
  }

  var I = function I(e) {
    var r = e.open,
        n = e.close,
        o = e.setLinkState,
        a = e.value,
        i = b.createRef();
    return m.useEffect(function () {
      i.current && i.current.focus();
    }, [i]), b.createElement(t.Dialog, {
      open: r,
      onBackdropClick: n,
      fullWidth: !0,
      maxWidth: "sm"
    }, b.createElement(t.DialogContent, {
      style: {
        padding: 8
      }
    }, b.createElement("form", {
      onSubmit: function onSubmit(e) {
        e.preventDefault(), e.stopPropagation(), n();
      }
    }, b.createElement(t.TextField, {
      fullWidth: !0,
      placeholder: "Add URL",
      inputRef: i,
      variant: "outlined",
      value: a,
      onChange: function onChange(e) {
        e.persist(), o(function (t) {
          return _E(_E({}, t), {
            urlValue: e.target.value
          });
        });
      }
    }))));
  },
      B = function B(e) {
    var t = e.editorState,
        r = e.setEditorState,
        n = m.useState({
      showLinkDialog: !1,
      urlValue: "",
      entityKey: ""
    }),
        o = n[0],
        a = n[1];

    function i() {
      var e = o.urlValue,
          r = t.getCurrentContent();

      if (o.entityKey) {
        var n = o.entityKey,
            i = d.EditorState.set(t, {
          currentContent: r.replaceEntityData(o.entityKey, {
            url: e
          }),
          decorator: O({
            openLinkDialogWithUrl: function openLinkDialogWithUrl(e, t) {
              a({
                showLinkDialog: !0,
                urlValue: e,
                entityKey: t
              });
            }
          })
        });
        return d.RichUtils.toggleLink(i, i.getSelection(), n);
      }

      var l = r.createEntity("LINK", "MUTABLE", {
        url: e
      }),
          c = l.getLastCreatedEntityKey(),
          u = d.EditorState.set(t, {
        currentContent: l,
        decorator: O({
          openLinkDialogWithUrl: function openLinkDialogWithUrl(e, t) {
            a({
              showLinkDialog: !0,
              urlValue: e,
              entityKey: t
            });
          }
        })
      });
      return d.RichUtils.toggleLink(u, u.getSelection(), c);
    }

    return m.useEffect(function () {
      r(i());
    }, []), b.createElement(b.Fragment, null, b.createElement(I, {
      open: o.showLinkDialog,
      close: function close() {
        return r(i()), void a({
          showLinkDialog: !1,
          urlValue: "",
          entityKey: ""
        });
      },
      setLinkState: a,
      value: o.urlValue
    }), b.createElement(S, {
      onClick: function onClick() {
        if (!t.getSelection().isCollapsed()) {
          var e = t.getCurrentContent(),
              r = t.getSelection().getStartKey(),
              n = t.getSelection().getStartOffset(),
              o = e.getBlockForKey(r).getEntityAt(n);

          if (o) {
            var i = e.getEntity(o);
            a({
              showLinkDialog: !0,
              urlValue: i.getData().url,
              entityKey: o
            });
          }

          a(function (e) {
            return _E(_E({}, e), {
              showLinkDialog: !0
            });
          });
        }
      },
      label: "Insert link",
      active: !1,
      Icon: y
    }));
  },
      F = new d.CompositeDecorator([{
    strategy: D,
    component: function component(e) {
      var t = e.contentState,
          r = e.entityKey,
          n = e.children,
          o = t.getEntity(r).getData().url;
      return b.createElement(p.TitularTooltip, {
        description: o,
        enterDelay: 175
      }, b.createElement("span", null, b.createElement(f.HoverLink, {
        target: "_blank",
        rel: "noopener",
        to: o,
        external: !0,
        color: "primary",
        hoverColor: "primary"
      }, n)));
    }
  }]);

  var T = {
    STRIKETHROUGH: {
      textDecoration: "line-through"
    }
  },
      R = [{
    label: "Bulleted List",
    icon: n,
    style: "unordered-list-item"
  }, {
    label: "Numbered List",
    icon: o,
    style: "ordered-list-item"
  }],
      j = [{
    label: "Bold",
    icon: r,
    style: "BOLD"
  }, {
    label: "Italic",
    icon: a,
    style: "ITALIC"
  }, {
    label: "Underline",
    icon: i,
    style: "UNDERLINE"
  }, {
    label: "Strikethrough",
    icon: c,
    style: "STRIKETHROUGH"
  }, {
    label: "Monospace",
    icon: l,
    style: "CODE"
  }],
      U = function U(e) {
    var r,
        n,
        o = e.initialState,
        a = e.editorState,
        i = e.setEditorState,
        l = e.children,
        c = e.render,
        s = e.placeholder,
        p = m.useState(!1),
        f = p[0],
        y = p[1],
        g = m.useState(!1),
        h = g[0],
        E = g[1],
        S = m.useRef(null),
        k = m.useMemo(function () {
      var e = a.getCurrentContent();
      return !e.hasText() && "unstyled" !== e.getBlockMap().first().getType();
    }, [a.getCurrentContent()]),
        L = m.useCallback(i || function () {}, [i]);

    function x(e) {
      f || e.getCurrentContent() === a.getCurrentContent() || y(!0), !f || o || e.getCurrentContent().hasText() || y(!1), L(e);
    }

    var O = P();
    return b.createElement("div", {
      className: u(O.container, (r = {}, r[O.containerFocused] = h, r[O.readOnly] = !i, r))
    }, b.createElement("div", {
      onClick: function onClick() {
        i && S && S.current && (S.current.focus(), E(!0));
      },
      className: u(O.root, (n = {}, n[O.rootNoPadding] = !i, n))
    }, b.createElement(d.Editor, {
      onBlur: function onBlur() {
        S && S.current && (S.current.blur(), E(!1)), x(o || d.EditorState.createEmpty()), y(!1);
      },
      blockStyleFn: v,
      customStyleMap: T,
      handleKeyCommand: function handleKeyCommand(e, t) {
        var r = d.RichUtils.handleKeyCommand(t, e);
        return r ? (x(r), "handled") : "not-handled";
      },
      placeholder: k ? void 0 : s,
      editorState: a,
      onChange: x,
      ref: S,
      spellCheck: !0,
      readOnly: !i
    })), i ? b.createElement(t.Grid, {
      container: !0,
      className: O.controlsContainer,
      justify: "space-between",
      alignContent: "flex-start",
      alignItems: "flex-start"
    }, b.createElement(t.Grid, {
      item: !0
    }, b.createElement(t.Box, {
      display: "flex",
      flexWrap: "wrap"
    }, b.createElement(w, {
      editorState: a,
      onToggle: function onToggle(e) {
        x(d.RichUtils.toggleInlineStyle(a, e));
      },
      styles: j
    }), b.createElement(B, {
      editorState: a,
      setEditorState: i
    }), b.createElement(t.Box, {
      height: "auto",
      width: "1px",
      bgcolor: "#e9e9e9",
      marginX: 2
    }), b.createElement(C, {
      editorState: a,
      onToggle: function onToggle(e) {
        x(d.RichUtils.toggleBlockType(a, e));
      },
      styles: R
    }))), b.createElement(t.Grid, {
      xs: !0,
      item: !0,
      container: !0,
      justify: "flex-end",
      wrap: "nowrap"
    }, c && c({
      hasChanges: f
    }), l && l({
      hasChanges: f
    }))) : null);
  },
      N = function N(e) {
    var t = e.editorState,
        r = q(),
        n = function (e) {
      var t = e.getCurrentContent().createEntity("LINK", "MUTABLE"),
          r = t.getLastCreatedEntityKey(),
          n = d.EditorState.set(e, {
        currentContent: t,
        decorator: F
      });
      return d.RichUtils.toggleLink(n, n.getSelection(), r);
    }(t);

    return b.createElement("div", {
      className: r.root
    }, b.createElement(d.Editor, {
      onChange: function onChange() {},
      editorState: n,
      readOnly: !0
    }));
  },
      K = function K(e) {
    var t = e.setEditorState,
        r = e.readOnly;
    return t && !r ? b.createElement(U, _E({}, e)) : b.createElement(N, _E({}, e));
  },
      q = t.makeStyles(function () {
    return t.createStyles({
      root: {
        fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
      }
    });
  }),
      P = t.makeStyles(function (e) {
    return t.createStyles({
      container: {
        backgroundColor: "white",
        borderRadius: 4,
        padding: 1,
        border: "solid 1px rgba(0, 0, 0, 0.25)",
        width: "100%",
        boxSizing: "border-box",
        transition: "border-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        "&:hover": {
          cursor: "text",
          borderColor: "rgba(0, 0, 0, 0.54)",
          "& $controlsContainer": {
            borderColor: "rgba(0, 0, 0, 0.54)"
          }
        }
      },
      containerFocused: {
        padding: 0,
        border: "solid 2px " + e.palette.primary.main,
        "&:hover": {
          cursor: "text",
          borderColor: e.palette.primary.main
        },
        "& $controlsContainer": {
          borderColor: e.palette.primary.main
        }
      },
      root: {
        paddingTop: 12,
        paddingLeft: 9,
        paddingRight: 6,
        paddingBottom: 12,
        "& .public-DraftEditor-content": {
          minHeight: 58
        },
        "& .public-DraftEditorPlaceholder-root": {
          marginBottom: -18,
          color: "rgba(0,0,0,0.3)"
        },
        "& .public-DraftStyleDefault-block": {
          overflowWrap: "break-word",
          wordWrap: "break-word",
          wordBreak: "break-all",
          hyphens: "auto"
        },
        fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
      },
      controlsContainer: {
        borderTop: "solid 1px rgba(0, 0, 0, 0.25)",
        padding: 12
      },
      readOnly: {
        backgroundColor: "rgba(0,0,0,0)",
        padding: 0,
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0)"
        }
      },
      rootNoPadding: {
        "& .public-DraftEditor-content": {
          minHeight: 0
        }
      }
    });
  }),
      H = function H(e) {
    if (!e) return d.EditorState.createEmpty();

    try {
      return d.EditorState.createWithContent(d.convertFromRaw(JSON.parse(e)));
    } catch (e) {
      return d.EditorState.createEmpty();
    }
  };

  e.CampfireRichEditor = K, e.RichEditorFormik = function (e) {
    var t = e.valueName,
        r = void 0 === t ? "editor" : t,
        n = e.placeholder,
        o = s.useFormikContext(),
        a = o.values,
        i = o.setFieldValue,
        l = a[r],
        c = m.useState(function () {
      return H(l);
    }),
        u = c[0],
        p = c[1],
        f = m.useRef(l);
    return m.useEffect(function () {
      l !== f.current && (f.current = l, p(H(l)));
    }, [l]), m.useEffect(function () {
      var e = JSON.stringify(d.convertToRaw(u.getCurrentContent()));
      e !== f.current && (f.current = e, i(r, e));
    }, [u]), b.createElement(K, {
      placeholder: n,
      editorState: u,
      setEditorState: p
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});